import { IssuesList } from './IssuesList';
import { IssueVisibilityType } from '@sonar-software/sonar-issues';
import React from 'react';

export interface VisibleIssuesListProps {
	hideActions?: boolean;
	limit?: number;
}

export const VisibleIssuesList: React.FC<VisibleIssuesListProps> = ({ hideActions, limit }) =>
	<IssuesList
		hideActions={ hideActions }
		limit={ limit }
		visibility={ IssueVisibilityType.Visible } />;

